import { TranslatedCalling } from './common';

export const fetch_user_collections = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-user-collections.checking" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-user-collections.checking" />,
  result: () => null,
};
